/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ResultsFeedServicePlugins {
   plugins: any[]
   constructor(__: any) {
      this.plugins = _(arguments).toArray() // use all injected dependencies
   }
}

// NOTE:
// The order of injecting the plugins matters.
// Plugins that insert positional items should be listed first.
// If more than one plugin requests the same positional slot,
// the plugin that was loaded first will be put first in that slot,
// then the next, etc
ResultsFeedServicePlugins.$inject = [
   'searchInfoPlugin',
   'didYouMeanPlugin',
   'bestBetsPlugin',
   'databaseRecommendationsPlugin',
   'noResultsPlugin',
   'imagesRollupPlugin',
   'newsRollupPlugin',
   'referencesRollupPlugin',
   'querySuggestionsPlugin',
   'documentSummariesPlugin'
]

angular.module('summonApp.services')
   .service('resultsFeedServicePlugins', ResultsFeedServicePlugins)
